import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41a29d00"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-caption mb-1" }, "Última grabación:", -1))
const _hoisted_3 = ["src"]

import { ref, onBeforeUnmount } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'Test-EO',
  setup(__props) {

const speakText = (text: string) => {
  if (!window.speechSynthesis) {
    alert("Tu navegador no soporta la reproducción de voz.");
    return;
  }

  // Crear el objeto de locución
  const utterance = new SpeechSynthesisUtterance(text);
  
  // Configuración opcional
  utterance.lang = 'es-ES'; // Idioma
  utterance.pitch = 1;      // Tono (0 a 2)
  utterance.rate = 1;       // Velocidad (0.1 a 10)
  utterance.volume = 1;     // Volumen (0 a 1)

  // Opcional: Elegir una voz específica disponible en el sistema
  const voices = window.speechSynthesis.getVoices();
  // Por ejemplo, buscar una voz que suene más natural si existe
  const spanishVoice = voices.find(v => v.lang.includes('es'));
  if (spanishVoice) utterance.voice = spanishVoice;

  // ¡Hablar!
  window.speechSynthesis.speak(utterance);
};

// --- ESTADOS ---
const isRecording = ref(false);
const transcription = ref('');
const audioUrl = ref<string | null>(null);
const audioPlayer = ref<HTMLAudioElement | null>(null);

// --- VARIABLES DE NAVEGADOR ---
let mediaRecorder: MediaRecorder | null = null;
let audioChunks: Blob[] = [];
let recognition: any = null;

// --- CONFIGURACIÓN DE SPEECH RECOGNITION (Voz a Texto) ---
const setupSpeechRecognition = () => {
  const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
  
  if (!SpeechRecognition) {
    alert("Tu navegador no soporta el reconocimiento de voz.");
    return;
  }

  recognition = new SpeechRecognition();
  recognition.lang = 'es-ES'; // Idioma
  recognition.continuous = true;
  recognition.interimResults = true;

  recognition.onresult = (event: any) => {
    let interimTranscript = '';
    for (let i = event.resultIndex; i < event.results.length; ++i) {
      if (event.results[i].isFinal) {
        transcription.value += event.results[i][0].transcript + ' ';
      } else {
        interimTranscript += event.results[i][0].transcript;
      }
    }
  };
};

// --- LOGICA DE GRABACIÓN ---
const startAll = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    
    // 1. Iniciar Grabación de Audio
    mediaRecorder = new MediaRecorder(stream);
    audioChunks = [];
    
    mediaRecorder.ondataavailable = (e) => audioChunks.push(e.data);
    mediaRecorder.onstop = () => {
      const audioBlob = new Blob(audioChunks, { type: 'audio/webm' });
      audioUrl.value = URL.createObjectURL(audioBlob);
    };

    mediaRecorder.start();

    // 2. Iniciar Reconocimiento de Voz
    if (!recognition) setupSpeechRecognition();
    recognition.start();

    isRecording.value = true;
  } catch (err) {
    console.error("Error al acceder al micrófono:", err);
  }
};

const stopAll = () => {
  mediaRecorder?.stop();
  recognition?.stop();
  isRecording.value = false;
};

const playAudio = () => {
  audioPlayer.value?.play();
};

const clearAll = () => {
  transcription.value = '';
  audioUrl.value = null;
  audioChunks = [];
};

// Limpiar recursos al destruir componente
onBeforeUnmount(() => {
  stopAll();
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "fill-height" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8",
            lg: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "pa-6",
                elevation: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-h5 text-center mb-4" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 🎙️ Laboratorio de Voz ")
                    ]),
                    _: 1
                  }),
                  (isRecording.value)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        type: "info",
                        variant: "tonal",
                        class: "mb-4",
                        icon: "mdi-microphone"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Escuchando... hable ahora. ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_divider, { class: "mb-6" }),
                  _createVNode(_component_v_row, {
                    justify: "center",
                    class: "mb-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: isRecording.value ? 'red' : 'primary',
                        size: "large",
                        icon: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (isRecording.value ? stopAll() : startAll())),
                        class: "mx-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(isRecording.value ? 'mdi-stop' : 'mdi-microphone'), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_v_btn, {
                        disabled: !audioUrl.value || isRecording.value,
                        color: "success",
                        variant: "outlined",
                        size: "large",
                        icon: "",
                        onClick: playAudio,
                        class: "mx-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-play")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        disabled: !transcription.value,
                        color: "secondary",
                        variant: "elevated",
                        icon: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (speakText(transcription.value))),
                        class: "mx-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-volume-high")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_textarea, {
                    modelValue: transcription.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((transcription).value = $event)),
                    label: "Transcripción (Texto)",
                    variant: "outlined",
                    placeholder: "Lo que digas aparecerá aquí...",
                    readonly: "",
                    rows: "4",
                    "auto-grow": "",
                    "bg-color": "grey-lighten-4"
                  }, null, 8, ["modelValue"]),
                  (audioUrl.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("audio", {
                          ref_key: "audioPlayer",
                          ref: audioPlayer,
                          src: audioUrl.value,
                          controls: "",
                          class: "w-100"
                        }, null, 8, _hoisted_3)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_card_actions, { class: "mt-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        color: "grey",
                        onClick: clearAll,
                        disabled: isRecording.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Limpiar todo ")
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})